// removed by extract-text-webpack-plugin
module.exports = {"formFeedback":"_2jvjobWENV9FiPRuMM8-YK","btnSend":"_8-KH55mel_v1Smo9qXTpC"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FormFeedback/FormFeedback.scss
 ** module id = 813
 ** module chunks = 0
 **/